import React from 'react';
import GenericTable from '../general/generic-table';
import { utilService } from "../../services/util-service"


interface ControlTableProps {
  data: any; // Array of ComponentItem objects
}

// Functional component to render the array of objects
const ControlTable: React.FC<ControlTableProps> = ({ data }) => {
  const createMapping = (title: string, location: string[], type: string, trueText?: string, falseText?: string) => {
    return ({
      title,
      location,
      type,
      trueText,
      falseText
    })
  }

  const mapping = [
    createMapping('Control ID', ['id'], 'string'),
    createMapping('Entity Name', ['mainSystem', 'entity', 'name'], 'string'),
    createMapping('Objective Name', ['objective', 'name'], 'string'),
    createMapping('Main System Name', ['mainSystem', 'system', 'name'], 'string'),
    createMapping('HR System Name', ['hrSystem', 'system', 'name'], 'string'),
    createMapping('Ticket System Name', ['ticketSystem', 'system', 'name'], 'string'),
    createMapping('Consolidation Rules', ['systemConsolidations'], 'array'),
  ];
  

  let tableData: any = []
  for (let index = 0; index < data.length; index++) {
    let itemData = []
    for (let i = 0; i < mapping.length; i++) {
      let element: any = {}
      element.title = mapping[i].title;

      element.value = utilService.getCellValue(data[index], mapping[i])

      element.type = mapping[i].type;
      itemData.push(element)
    }
    tableData.push(itemData)
  }
  return (<GenericTable data={tableData} recordName="Controls" />);
};

export default ControlTable;
